import { Button } from 'components/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from 'components/Dialog';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';

interface DuplicateLoadWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function DuplicateLoadWarningDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}: DuplicateLoadWarningDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <Flex direction='col' gap='sm' className='p-4'>
          <DialogTitle>Submit Another Load?</DialogTitle>
          <DialogDescription>
            <Typography variant='body-sm'>
              You just successfully created a load.
            </Typography>
            <Typography variant='body-sm' className='mt-2' weight='medium'>
              Are you sure you want to submit another load?
            </Typography>
          </DialogDescription>
          <Flex direction='row' gap='sm' className='w-full mt-4' justify='end'>
            <Button
              variant='outline'
              size='sm'
              onClick={() => onOpenChange(false)}
              buttonNamePosthog={null}
              className='border-neutral-900 text-sm'
            >
              Cancel
            </Button>
            <Button
              variant='default'
              size='sm'
              onClick={onConfirm}
              disabled={!!isLoading}
              buttonNamePosthog={ButtonNamePosthog.BuildLoad}
              className='text-sm'
            >
              {isLoading ? 'Creating...' : 'Yes, Create Another'}
            </Button>
          </Flex>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
